import {
  ARTICLE_FAVORITED,
  ARTICLE_UNFAVORITED,
  SET_PAGE,
  APPLY_TAG_FILTER,
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  CHANGE_TAB,
  QN_PAGE_LOADED,
  QN_PAGE_UPDATE,
  QN_PAGE_UNLOADED,
  ANS_PAGE_LOADED,
  ANS_PAGE_UNLOADED,
  ANS_PAGE_UPDATE,
  PROFILE_FAVORITES_PAGE_LOADED,
  PROFILE_FAVORITES_PAGE_UNLOADED,
  ANSWER_FAVORITED,
  ANSWER_UNFAVORITED
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case ARTICLE_FAVORITED:
      return {
        ...state,
        articles: state.articles.map(article => {
          if (article.id === action.payload.questionId) {
            return {
              ...article,
              hasVoted: '1',
              voteCount: (parseInt(article.voteCount) + 1)
            };
          }
          return article;
        })
      };
    case ARTICLE_UNFAVORITED:
      return {
        ...state,
        articles: state.articles.map(article => {
          if (article.id === action.payload.questionId) {
            return {
              ...article,
              hasVoted: '0',
              voteCount: (parseInt(article.voteCount) - 1)
            };
          }
          return article;
        })
      };
    case ANSWER_FAVORITED:
      return {
        ...state,
        answers: state.answers.map(article => {
          if (article.id === action.payload.questionId) {
            return {
              ...article,
              hasVoted: '1',
              voteCount: (parseInt(article.voteCount) + 1)
            };
          }
          return article;
        })
      };
    case ANSWER_UNFAVORITED:
      return {
        ...state,
        answers: state.answers.map(article => {
          if (article.id === action.payload.questionId) {
            return {
              ...article,
              hasVoted: '0',
              voteCount: (parseInt(article.voteCount) - 1)
            };
          }
          return article;
        })
      };
    case SET_PAGE:
      return {
        ...state,
        articles: action.payload.articles,
        articlesCount: action.payload.articlesCount,
        currentPage: action.page
      };
    case APPLY_TAG_FILTER:
      return {
        ...state,
        pager: action.pager,
        articles: action.payload.articles,
        articlesCount: action.payload.articlesCount,
        tab: null,
        tag: action.tag,
        currentPage: 0
      };
    case HOME_PAGE_LOADED:
      return {
        ...state,
        pager: action.pager,
        tags: action.payload[0].tags,
        articles: action.payload[1].articles,
        articlesCount: action.payload[1].articlesCount,
        currentPage: 0,
        tab: action.tab
      };
    case HOME_PAGE_UNLOADED:
      return {};
    case CHANGE_TAB:
      return {
        ...state,
        pager: action.pager,
        articles: action.payload.articles,
        articlesCount: action.payload.articlesCount,
        tab: action.tab,
        currentPage: 0,
        tag: null
      };
    case QN_PAGE_UPDATE:
      return {
        ...state,
        articles: state.articles.concat(action.payload[0])
      };
    case QN_PAGE_LOADED:
    case PROFILE_FAVORITES_PAGE_LOADED:
      return {
        ...state,
        articles: action.payload[0]
      };
    case ANS_PAGE_UPDATE:
      return {
        ...state,
        answers: state.answers.concat(action.payload[0])
      };
    case ANS_PAGE_LOADED:
      return {
        ...state,
        answers: action.payload[0],
      };
    case QN_PAGE_UNLOADED:
    case ANS_PAGE_UNLOADED:
    case PROFILE_FAVORITES_PAGE_UNLOADED:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/articleList.js